import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CommonServiceService } from './../../core/services/common-service/common-service.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Component({
    selector: 'app-dashboard-home',
    templateUrl: './dashboard-home.component.html',
    styleUrls: ['./dashboard-home.component.scss'],
})
export class DashboardHomeComponent {
    carouselData: any = [
        {
            title: 'Intelligent Discovery',
            image: '../../../assets/icons/carousel-1.svg',
            content:
                'Gyan acts as a metasearch engine, sourcing content from multiple sources identified by Gyan or specified by you, retrieving the most relevant results from across all sources.',
        },
        {
            title: 'Knowledge Graphs',
            image: '../../../assets/icons/carousel-2.svg',
            content: 'Knowledge Graphs Visually navigate through content in articles, individually or collectively. Discover unexpected connections. Fully traceable to source.',
        },
        {
            title: 'Summary and Synthesis',
            image: '../../../assets/icons/carousel-3.svg',
            content:
                'A summary is generated for each article along with a synthesized summary for all articles. Gyan summaries are traceable to specific sentences in source articles.',
        },
    ];
    customOptions: OwlOptions = {
        loop: true,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        dots: true,
        navSpeed: 300,
        navText: ['&#8249', '&#8250;'],
        autoWidth: true,
        autoplay: true,
        nav: false,
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 1,
            },
            740: {
                items: 1,
            },
            940: {
                items: 1,
            },
        },
    };

    customOptions_desktop: OwlOptions = {
        loop: false,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        dots: false,
        navSpeed: 300,
        navText: ['&#8249', '&#8250;'],
        autoWidth: true,
        autoplay: false,
        nav: false,
    };

    private loadingAfterSocket: Subscription;
    isLoading: boolean = true;
    isMobile: boolean = false;

    constructor(
        private commonServiceService: CommonServiceService,
        private toastr: ToastrService,
        private authservice: AuthService,
    ) {
        // calling subject to show and hide dahsboard screen
        this.loadingAfterSocket = this.commonServiceService.loadingAfterSocket$.subscribe((value) => {
            if (value) {
                this.waitForUserDetails().then((userDetails) => {
                    if (userDetails) {
                        this.isLoading = false;
                    }
                });
                // console.log('calling subject to show and hide dahsboard screen');
            }
        });
    }

    waitForUserDetails(): Promise<any> {
        return new Promise((resolve) => {
            const checkLocalStorage = () => {
                const userDetails = localStorage.getItem('userDetails');
                if (userDetails) {
                    resolve(JSON.parse(userDetails));
                } else {
                    setTimeout(checkLocalStorage, 100); // Poll every 500ms
                }
            };

            checkLocalStorage();
        });
    }

    ngOnInit() {
        if (!this.authservice.isSignInUser()) {
            setTimeout(() => {
                this.isLoading = false;
            }, 1000);
        }
        this.checkWidth();
        // setTimeout(() => {
        //     this.toastr.success();
        // }, 1000);
        // setTimeout(() => {
        //     this.toastr.warning();
        // }, 2000);
        // setTimeout(() => {
        //     this.toastr.error('gyan submission failed');
        // }, 3000);
    }

    checkWidth() {
        const width = window.innerWidth;
        // console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }
    ngOnDestroy() {
        this.loadingAfterSocket.unsubscribe();
    }
}
